export const messages = {
    "shared-link.footer.link.install": "Cuba {brandName} secara percuma",
    "shared-link.footer.link.mobile": "{brandName} untuk Telefon bimbit",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Data dilindungi",
    "shared-link.password-dialog-box.message": "Sila nyatakan kata laluan untuk mengakses data dikongsi",
    "shared-link.password-dialog-box.hint.password": "Kata laluan",
    "shared-link.password-dialog-box.message.invalid-password": "Kata laluan salah",
    "shared-link.form.button.open": "Buka",
    "shared-link.page-not-found.title": "Halaman tidak ditemui",
    "shared-link.page-not-found.message.main": "Halaman yang anda cari tidak dijumpai.",
    "shared-link.page-not-found.message.description": "Pautan ini mungkin sudah lapuk, atau anda mungkin telah menaip alamat yang salah.",
    "shared-link.page-not-found.message.error": "Kod ralat: 404",
    "shared-link.restore-file.label.size": "Saiz",
    "shared-link.restore-file.button.restore": "Muat turun",
    "shared-link.links-table.column.name": "Nama",
    "shared-link.links-table.column.size": "Saiz",
    "shared-link.links-table.action.restore": "Muat turun",
    "shared-link.links-table.action.restore-all": "Muat turun semua",
    "shared-link.side-bar.selected.title:plural": "{count} item dipilih | {count} item dipilih",
    "shared-link.links-table.label.size": "Saiz",
    "shared-link.links-table.message.empty-folder": "Folder ini kosong"
};
